// extracted by mini-css-extract-plugin
export default {"more":"Home_more__lEFiN","noticeBar":"Home_noticeBar__gckmf"};